import React from 'react'

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Image } from 'pure-react-carousel'
import styled from 'styled-components'
import 'pure-react-carousel/dist/react-carousel.es.css'

import { devices, ThumbnailsIcon, colors } from '../../Common'
// import { SimpleCarousel } from './SimpleCarousel'

export const LightBoxModal = ({ slides, showLightBox, activeImage, closeModal }) => {
    // const getActiveIndex = () => {
    //     for (let i = 0; i < slides.length; i++) {
    //         if (slides[i].image === activeImage) return i
    //     }
    // }

    return (
        <LBModal show={showLightBox}>
            <CarouselContainer>
                <StyledCarouselProvider
                    totalSlides={slides.length}
                    visibleSlides={1}
                    dragEnabled={false}
                    step={1}
                    // mobile={mobile ? 1 : 0}
                    isIntrinsicHeight={true}
                >
                    <Prev />
                    <SliderWrap>
                        {slides.map((slide, i) => (
                            <Slide key={i} index={i} className={'custom-slide'} classNameHidden={'slide-hidden'} classNameVisible={'slide-visible'}>
                                <StyledImage key={slide.image} src={slide.image} alt={slide.alt_text} />
                            </Slide>
                        ))}
                    </SliderWrap>
                    <Next />
                </StyledCarouselProvider>
                <ThumbnailButton onClick={closeModal}>
                    <ThumbnailsIcon />
                    Show Thumbnails
                </ThumbnailButton>
            </CarouselContainer>
        </LBModal>
    )
}

const SliderWrap = styled(Slider)`
    div,ul,li {
        outline: none !important;
    }
`

const CarouselContainer = styled.div`
    width: 100%;
    @media ${devices.small} {
        width: 100%;
    }
`

const StyledCarouselProvider = styled(CarouselProvider)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    .carousel__slider--horizontal {
        /* flex: 0 1 33%; */
        width: 100%;
        height: 100%;

        @media ${devices.small} {
            margin: 0 0 20px;
            .carousel__inner-slide {
                padding: 0;
            }
        }
    }

    .carousel__next-button,
    .carousel__back-button {
        border: none;
        z-index: 1;
        outline: none !important;
        &:disabled {
            cursor: default;
        }
    }

    .carousel__back-button {
        transform: rotate(180deg);
    }
`

const StyledImage = styled(Image)`
    border: 10px solid white;
`

const ThumbnailButton = styled.div`
    margin-left: 4%;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.white};
    font-weight: 900;
    font-size: 12px;
    width: 18%;
    cursor: pointer;
`

const LBModal = styled.div`
    padding: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${devices.small} {
        width: 100%;
        height: 100%;
        padding: 0;
    }
`

const Next = styled(ButtonNext)`
    background: url('/static/images/sprite.svg') no-repeat -125px -2px;
    width: 26px;
    height: 44px;
`

const Prev = styled(ButtonBack)`
    background: url('/static/images/sprite.svg') no-repeat -125px -2px;
    width: 26px;
    height: 44px;
`